import React from "react";
import { useState } from 'react';
import { ICreateCategoriaTransporte, ICreateMarca, ICreateModelo, ITablaCategoriaTransporte, ITablaMarca, ITablaModelo, IUpdateModelo } from "../../../interfaces/ITransporte";
import { DetailsListLayoutMode, IColumn } from '@fluentui/react/lib/DetailsList';
import { TextField, TooltipHost, Icon, PanelType, ICommandBarItemProps, MessageBar, MessageBarType, MessageBarButton, ProgressIndicator, SharedColors, mergeStyleSets, ComboBox, IComboBox, IComboBoxOption } from '@fluentui/react';
import { TableBase } from "../../../components/Table/TableBase";
import { HeadingBar } from "../../../components/Generic/HeadingBar";
import { PanelPlantillaFiltro } from "../../../components/PanelUpload/PanelPlantillaFiltro";
import { useBoolean } from '@fluentui/react-hooks';
import TransporteService from '../../../services/transporteService';
import { IconHelper } from "../../../utils/Helper/iconHelper";
import { useEffect } from 'react';
import { DialogBaseAlert } from "../../../components/Dialog/DialogBaseAlert";
import { IItemComboBaseDTO } from "../../../interfaces/base/IBase";
import { DialogBaseWait } from "../../../components/Dialog/DialogBaseWait";
import { DialogBaseSuccess } from "../../../components/Dialog/DialogBaseSuccess";
import { DialogBaseError } from "../../../components/Dialog/DialogBaseError";
import { _initialPagination } from "../../../utils/Helper/helper";
import { IPagination } from "../../../interfaces/base/ITable";


const classNames = mergeStyleSets({

    iconFont: {
        padding: 0,
        fontSize: "14px",
        marginRight: 5,
        marginLeft: 2,
    },
});


function Modelo() {

    const [hidden, setHidden] = useState(false);

    const data: ITablaModelo[] = [];
    const [items, setItems] = useState(data);
    const [modelModelo, setmodelModelo] = useState<ICreateModelo>(null!);
    const [modelItem, setModelItem] = useState<IUpdateModelo>(null!)
    const [marcaCombo, setMarcaCombo] = useState<IItemComboBaseDTO[]>([]);

    const [search, setSearch] = useState("");

    //panel
    const [isOpenModelo, { setTrue: openModelo, setFalse: dismissModelo },] = useBoolean(false);
    const [isOpenModeloEditar, { setTrue: openModeloEditar, setFalse: dismissModeloEditar },] = useBoolean(false);

    //mensajes de estado
    const [verLoading, setVerLoading] = useState(false);
    const [mensajeTransaccion, setMensajeTransaccion] = useState("");
    const [tipoMensaje, setTipoMensaje] = useState(0);
    const [verLoadingBoton, setVerLoadingBoton] = useState(false);

    //dialog
    const [hideAlertEliminar, { toggle: toggleHideAlertEliminar }] = useBoolean(true);
    const [hideWaitEliminar, { toggle: toggleHideWaitEliminar }] = useBoolean(true);
    const [hideSuccessEliminar, { toggle: toggleHideSuccessEliminar }] = useBoolean(true);
    const [hideErrorEliminar, { toggle: toggleHideErrorEliminar }] = useBoolean(true);

    //paginacion----------------------------------------
    const [currentPage, setCurrentPage] = useState(_initialPagination().currentPage);
    const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
    const [total, setTotal] = useState(_initialPagination().total);
    const [pager, setPager] = useState<IPagination>({
        ..._initialPagination(),
        onPageChange: (page) => dataByPager(page),
        onSizeChange: (pageSize) => setPageSize(pageSize),
    });

    const dataByPager = (page) => {
        if (true) {
            setTotal(0);
            setPager({
                ...pager,
                currentPage: page,
            });
        }
    }
    /* Hook Pagination */
    useEffect(() => {
        setPager({
            ...pager,
            currentPage: currentPage,
        });

    }, [currentPage]);

    useEffect(() => {
        setPager({
            ...pager,
            onPageChange: (page) => dataByPager(page),
            onSizeChange: (pageSize) => setPageSize(pageSize),
            total: total,
        });
    }, [total]);
    //-------------------------------------------------------

    useEffect(() => {
        if (search.length == 0) {
            dataTablaModelo(search);
        }

    }, [search]);

    useEffect(() => {
        dataMarca();

    }, []);

    const dataMarca = () => {
        TransporteService.allMarca().then(res => {
            setMarcaCombo(res.data);
        }).catch((e: Error) => {
            alert(e.message);
        })
    }

    const dataTablaModelo = (search) => {

        setHidden(false);
        TransporteService.tablaModelo(search).then(res => {
            
            setItems(res.data.items);
            setTotal(res.data.total);
            setHidden(true);

        }).catch((err) => {
            alert(err.message);
            // setHidden(true);
        })

    }

    const CrearModelo = () => {

        setVerLoading(true);
        setVerLoadingBoton(true);
        TransporteService.postModelo(modelModelo)
            .then((res) => {
                if (res.status == 200) {
                    // alert("Se registró correctamente!!");
                    setMensajeTransaccion("Se ha creado correctamente");
                    setTipoMensaje(2);
                    setVerLoading(false);
                    setVerLoadingBoton(true);
                }

            }).catch(function (error) {
                if (error.response) {
                    // alert(e.message);
                    setMensajeTransaccion(error.response.data.detail)
                    setTipoMensaje(1);
                    setVerLoading(false);
                }
            });
    }

    const ActualizarMarca = () => {

        setVerLoading(true);
        setVerLoadingBoton(true);
        TransporteService.putModelo(modelItem)
            .then((res) => {
                if (res.status == 200) {
                    // alert("Se registró correctamente!!");
                    setMensajeTransaccion("Se ha actualizado correctamente");
                    setTipoMensaje(2);
                    setVerLoading(false);
                    setVerLoadingBoton(true);
                }

            }).catch(function (error) {
                if (error.response) {
                    // alert(e.message);
                    setMensajeTransaccion(error.response.data.detail)
                    setTipoMensaje(1);
                    setVerLoading(false);
                }
            });
    }

    const EliminarMarca = (modeloId: string) => {

        toggleHideWaitEliminar()
        TransporteService.deleteModelo(modeloId)
            .then((res) => {
                if (res.status == 200) {
                    // alert("Se registró correctamente!!");
                    toggleHideWaitEliminar()
                    toggleHideSuccessEliminar()
                    dataTablaModelo(search);

                }

            }).catch(function (error) {
                if (error.response) {
                    // alert(e.message);
                    toggleHideWaitEliminar()
                    setMensajeTransaccion(error.response.data.detail)
                    toggleHideErrorEliminar()

                }
            });
    }

    const _onChangeText = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ) => {
        if (event != undefined) {
            if (newValue != undefined) {
                let nameInput = event.currentTarget.getAttribute("name");

                switch (nameInput) {
                    case "modelo":

                        setmodelModelo({
                            ...modelModelo,
                            nombre: newValue.toUpperCase(),
                        });

                        break;
                    case "codigoModelo":
                        setmodelModelo({
                            ...modelModelo,
                            codigo: newValue,
                        });

                        break;

                    default:
                        break;
                }
            }
        }
    };

    const _onChangeTextEditar = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ) => {
        if (event != undefined) {
            if (newValue != undefined) {
                let nameInput = event.currentTarget.getAttribute("name");

                switch (nameInput) {
                    case "modelo":

                        setModelItem({
                            ...modelItem,
                            nombre: newValue.toUpperCase(),
                        });

                        break;
                    case "codigoModelo":
                        setModelItem({
                            ...modelItem,
                            codigo: newValue,
                        });

                        break;

                    default:
                        break;
                }
            }
        }
    };

    const _onChangeMarca = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, index?: number, value?: string) => {
        if (event != undefined) {
            if (option != undefined) {
                setmodelModelo({
                    ...modelModelo,
                    marcaId: option.key.toString()
                });
            }
        }
    }

    const columns: IColumn[] = [
        {
            key: "column1",
            name: "Modelo Vehículo",
            fieldName: "nombre",
            minWidth: 200,
            maxWidth: 200,

        },
        {
            key: "column2",
            name: "Código",
            fieldName: "codigo",
            minWidth: 200,
            maxWidth: 200,
        },
        {
            key: "column3",
            name: "Marca",
            fieldName: "marca",
            minWidth: 200,
            maxWidth: 200,
        },
        {
            key: "column4",
            name: "Opciones",
            fieldName: "opciones",
            minWidth: 100,
            // maxWidth: 100,
            isResizable: true,
            isCollapsible: true,
            data: "number",

            onRender: (item: ITablaModelo) => (
                <>
                    <TooltipHost content="Editar">
                        <Icon
                            style={{ cursor: "pointer" }}
                            iconName="Edit"
                            className={classNames.iconFont}
                            onClick={() => {
                                setModelItem({
                                    ...modelItem,
                                    modeloId: item.id,
                                    nombre: item.nombre,
                                    codigo: item.codigo,
                                    marca: item.marca
                                })
                                openModeloEditar();

                            }}
                        />
                    </TooltipHost>
                    <TooltipHost content="Eliminar">
                        <Icon
                            style={{ color: SharedColors.red10, cursor: "pointer" }}
                            iconName="Delete"
                            className={classNames.iconFont}
                            onClick={() => {
                                setModelItem({
                                    ...modelItem,
                                    modeloId: item.id,
                                    nombre: item.nombre,
                                    codigo: item.codigo,
                                    marca: item.marca
                                })
                                toggleHideAlertEliminar();

                            }}
                        />

                    </TooltipHost>

                </>
            ),
        }


    ]

    const _leftBar = () => {
        const _items: ICommandBarItemProps[] = [
            {
                ...IconHelper.ICON_ADD,
                onClick: () => openModelo(),
            },
            {
                ...IconHelper.ICON_RELOAD,
                onClick: () => dataTablaModelo(search),
            },

        ];

        return _items;
    };

    const _onChangeSearch = (ev?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => {
        if (newValue != undefined) {

            setSearch(newValue);
        }
    };

    const _onPressSearch = (newValue: string) => {
        dataTablaModelo(newValue);

    };

    const _onClearSearch = () => {
        setSearch("");
    };

    const _goBack = () => {
        dismissModelo();
        dataTablaModelo(search);
        setVerLoadingBoton(false);
        setTipoMensaje(3);
    }

    const _goBackEditar = () => {
        dismissModeloEditar();
        dataTablaModelo(search);
        setVerLoadingBoton(false);
        setTipoMensaje(3);
    }

    return (

        <>
            <div className="ms-Grid" dir="ltr">

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                        <HeadingBar
                            title={"Marca de vehículos"}
                            subTitle={"Detalle de marca de vehículos"}
                            searchPlaceholder="Buscar por modelo de vehículo"
                            searchChange={_onChangeSearch}
                            searchHandler={_onPressSearch}
                            searchValue={search}
                            onClearHandler={_onClearSearch}
                        ></HeadingBar>
                        <TableBase leftBar={_leftBar()} data={items} column={columns} isLoading={!hidden} pagination={pager} layout={DetailsListLayoutMode.justified} />

                    </div>
                </div>
            </div>
            <div id='panelNuevo'>
                <>
                    <PanelPlantillaFiltro
                        textHeader='Modelo de vehículo'
                        subTextHeader='Crear una nuevo modelo de vehículo'
                        textBoton='Guardar'
                        textBotonDefault='Cancelar'
                        onclickBoton={CrearModelo}
                        onclickBotonDefault={_goBack}
                        openPanel={isOpenModelo}
                        closePanel={dismissModelo}
                        size={PanelType.smallFixedFar}
                        estadoBarraEnvio={verLoadingBoton}
                        nameIconHeader={"Car"}
                        nameIconButton={"Save"}
                    >
                        <>
                            {tipoMensaje == 1 && (
                                <>
                                    <MessageBar
                                        messageBarType={MessageBarType.error}
                                        isMultiline={false}
                                        //onDismiss={p.resetChoice}
                                        dismissButtonAriaLabel="Close"
                                    //truncated={true}
                                    //overflowButtonAriaLabel="See more"
                                    >
                                        <b>{mensajeTransaccion}</b>{" "}
                                    </MessageBar>
                                    <br></br>
                                </>
                            )}
                            {tipoMensaje == 2 && (
                                <>
                                    <MessageBar
                                        actions={
                                            <div>
                                                <MessageBarButton onClick={() => _goBack()}>
                                                    Conforme
                                                </MessageBarButton>
                                            </div>
                                        }
                                        messageBarType={MessageBarType.success}
                                        isMultiline={false}
                                    >
                                        {mensajeTransaccion}
                                    </MessageBar>
                                    <br></br>
                                </>
                            )}
                            {!verLoading && (
                                <form action="">
                                    <div className="ms-Grid" dir="ltr">
                                        <div className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                                <TextField
                                                    label="Modelo:"
                                                    placeholder="Modelo de vehículo"
                                                    name="modelo"
                                                    value={modelModelo?.nombre}
                                                    onChange={(e, o) => _onChangeText(e, o)}

                                                />
                                                <br />
                                                <TextField
                                                    label="Código: "
                                                    name="codigoModelo"
                                                    value={modelModelo?.codigo}
                                                    onChange={(e, o) => _onChangeText(e, o)}

                                                />
                                                <br />
                                                <ComboBox
                                                    label="Marca"
                                                    options={marcaCombo}
                                                    autoComplete='off'
                                                    useComboBoxAsMenuWidth
                                                    calloutProps={{ directionalHintFixed: true }}
                                                    onChange={_onChangeMarca}
                                                    selectedKey={modelModelo?.marcaId}

                                                />

                                            </div>

                                        </div>
                                    </div>
                                </form>
                            )}
                            {verLoading && (
                                <>
                                    <br></br>
                                    <ProgressIndicator
                                        barHeight={5}
                                        label="Enviando información"
                                        description="Favor Espere un momento"
                                    />
                                </>
                            )}
                        </>
                    </PanelPlantillaFiltro>
                </>
            </div>
            <div id='panelEditar'>
                <>
                    <PanelPlantillaFiltro
                        textHeader='Editar modelo'
                        subTextHeader={`Edite del vehículo el modelo: ${modelItem?.nombre}`}
                        textBoton='Actualizar'
                        textBotonDefault='Cancelar'
                        onclickBoton={ActualizarMarca}
                        onclickBotonDefault={dismissModeloEditar}
                        openPanel={isOpenModeloEditar}
                        closePanel={dismissModeloEditar}
                        size={PanelType.smallFixedFar}
                        estadoBarraEnvio={verLoadingBoton}
                        nameIconHeader={"Car"}

                    >
                        <>
                            {tipoMensaje == 1 && (
                                <>
                                    <MessageBar
                                        messageBarType={MessageBarType.error}
                                        isMultiline={false}
                                        //onDismiss={p.resetChoice}
                                        dismissButtonAriaLabel="Close"
                                    //truncated={true}
                                    //overflowButtonAriaLabel="See more"
                                    >
                                        <b>{mensajeTransaccion}</b>{" "}
                                    </MessageBar>
                                    <br></br>
                                </>
                            )}
                            {tipoMensaje == 2 && (
                                <>
                                    <MessageBar
                                        actions={
                                            <div>
                                                <MessageBarButton onClick={() => _goBackEditar()}>
                                                    Conforme
                                                </MessageBarButton>
                                            </div>
                                        }
                                        messageBarType={MessageBarType.success}
                                        isMultiline={false}
                                    >
                                        {mensajeTransaccion}
                                    </MessageBar>
                                    <br></br>
                                </>
                            )}
                            {!verLoading && (
                                <form action="">
                                    <div className="ms-Grid" dir="ltr">
                                        <div className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                                <TextField
                                                    label="Modelo: "
                                                    placeholder="Modelo del vehículo"
                                                    name='modelo'
                                                    value={modelItem?.nombre}
                                                    onChange={(e, o) => _onChangeTextEditar(e, o)}
                                                />
                                                <br />
                                                <TextField
                                                    label="Código: "
                                                    placeholder="08"
                                                    name="codigoModelo"
                                                    value={modelItem?.codigo}
                                                    onChange={(e, o) => _onChangeTextEditar(e, o)}

                                                />
                                                <br />
                                                <TextField
                                                    label="Marca:"
                                                    name="marca"
                                                    value={modelItem?.marca}
                                                    disabled
                                                // value={modelModelo?.orden}
                                                // onChange={(e, o) => _onChangeText(e, o)}

                                                />

                                            </div>

                                        </div>
                                    </div>
                                </form>
                            )}
                            {verLoading && (
                                <>
                                    <br></br>
                                    <ProgressIndicator
                                        barHeight={5}
                                        label="Enviando información"
                                        description="Favor Espere un momento"
                                    />
                                </>
                            )}
                        </>
                    </PanelPlantillaFiltro>
                </>
            </div>
            <div id="dialogAlertElimnar">
                <DialogBaseAlert
                    hideDialog={hideAlertEliminar}
                    toggleHideDialog={toggleHideAlertEliminar}
                    title="¡Atención!"
                    subText={`¿Está seguro que desea eliminar al modelo de vehículo ${modelItem?.nombre}?`}
                    onclickButtonPrimary={() => EliminarMarca(modelItem?.modeloId)}
                />
            </div>
            <div id="dialogWaitElimnar">
                <DialogBaseWait
                    hideDialog={hideWaitEliminar}
                    toggleHideDialog={toggleHideWaitEliminar}
                />
            </div>
            <div id="dialogSuccesssElimnar">
                <DialogBaseSuccess
                    hideDialog={hideSuccessEliminar}
                    toggleHideDialog={toggleHideSuccessEliminar}
                    subText={`Se ha eliminado el modelo ${modelItem?.nombre} del la marca de vehículo ${modelItem?.marca}?`}
                />
            </div>
            <div id="dialogErrorEliminar">
                <DialogBaseError
                    hideDialog={hideErrorEliminar}
                    toggleHideDialog={toggleHideErrorEliminar}
                    subText={mensajeTransaccion}
                />
            </div>

        </>
    );
}

export { Modelo }